import { DateTime } from 'luxon';

export const startOfSundayWeek = (date: DateTime) => (
    date.minus({ days: date.weekday % 7 }).startOf('day')
);

export const endOfSaturdayWeek = (date: DateTime) => (
    startOfSundayWeek(date).plus({ days: 6 }).endOf('day')
);

const getWeekDays = ({
    date,
    timeZone,
}: {
    date: Date;
    timeZone: string;
}) => {
    const start = startOfSundayWeek(
        DateTime.fromJSDate(date).setZone(timeZone),
    );

    return Array.from({ length: 7 }, (_, index) => start.plus({ days: index }).toJSDate());
};

export default getWeekDays;
